export class Milliseconds {
  static fromSeconds(seconds: number): number {
    return seconds * 1000;
  }

  static toSeconds(milliseconds: number): number {
    return milliseconds / 1000;
  }

  static fromMinutes(minutes: number): number {
    return this.fromSeconds(minutes * 60);
  }

  static toMinutes(milliseconds: number): number {
    return this.toSeconds(milliseconds) / 60;
  }

  static fromHours(hours: number): number {
    return this.fromMinutes(hours * 60);
  }

  static toHours(milliseconds: number): number {
    return this.toMinutes(milliseconds) / 60;
  }

  static fromDays(days: number): number {
    return this.fromHours(days * 24);
  }

  static toDays(milliseconds: number): number {
    return this.toHours(milliseconds) / 24;
  }
}
